import { OverviewMapControls } from './OverviewMapControls';
import { MapDot } from '../../../SharedComponents/Map/Dots/Dots';
import { useOverviewMapData } from './OverviewMap.hooks';
import { CustomerAnalyticsPage } from '../../../SharedComponents/CustomerAnalyticsPage';
import { OverviewMapSidebar } from './OverviewMapSidebar';
import dynamic from 'next/dynamic';
import { PageLoading } from '../../../SharedComponents/PageLoading';

const MapWithGeoJson = dynamic(
  () => import('../../../SharedComponents/Map/MapWithGeoJson').then((mod) => mod.MapWithGeoJson),
  {
    ssr: false,
    loading: () => <PageLoading />,
  },
);

export const OverviewMap = () => {
  const {
    showRegularProperties,
    showClaimedProperties,
    setShowRegularProperties,
    setShowClaimedProperties,
    advertisedProperties,
    claimedProperties,
    dotsToRender,
    topPropertiesByProspects,
    bottomPropertiesByProspects,
    sidebarTitle,
  } = useOverviewMapData();

  return (
    <CustomerAnalyticsPage
      header="Portfolio performance overview"
      subheader="Source: Zillow internal data"
      sidebarTitle={sidebarTitle}
      sidebar={
        <OverviewMapSidebar
          top5PropertiesByLead={topPropertiesByProspects}
          bottom5PropertiesByLead={bottomPropertiesByProspects}
        />
      }
    >
      <MapWithGeoJson>
        <OverviewMapControls
          showRegularProperties={showRegularProperties}
          showClaimedProperties={showClaimedProperties}
          setShowRegularProperties={setShowRegularProperties}
          setShowClaimedProperties={setShowClaimedProperties}
          advertisedProperties={advertisedProperties}
          claimedProperties={claimedProperties}
        />
        {dotsToRender.map(({ key, payload }) => (
          <MapDot key={key} payload={payload} />
        ))}
      </MapWithGeoJson>
    </CustomerAnalyticsPage>
  );
};
